import React from "react";
import { useNexauraData } from "../context/NexauraContext";
import Button from "../components/common/Button";
import Gauge from "../components/common/Gauge";
import { fmtUsdt, boardState, boardPct } from "../utils/format";

export default function Boards() {
  const { data, busy, upgrade, retopup } = useNexauraData();

  const packages = data.packages; // bool[12]
  const details = data.packageDetails; // [12]
  const prices = data.prices;

  const isUpgradable = (boardId) => {
    if (packages[boardId - 1]) return false;
    if (boardId === 1) return false;
    return packages[boardId - 2];
  };

  return (
    <div className="screen">
      <div className="screen-title">Boards</div>
      <div className="screen-sub">12 boards · live ceiling tracker.</div>

      <div className="boards-list">
      {Array.from({ length: 12 }, (_, i) => {
        const boardId = i + 1;
        const active = packages[boardId - 1];
        const upgradable = isUpgradable(boardId);
        const locked = !active && !upgradable;
        const det = details[boardId - 1];
        const pct = boardPct(det);
        const st = boardState(det); // live | warn | full | locked
        const nextInactive = boardId < 12 && !packages[boardId];
        const statusText = active
          ? st === "full" ? "● Ceiling Hit" : st === "warn" ? "● Nearing Ceiling" : "● Live"
          : upgradable ? "Available" : "Locked";

        return (
          <div
            key={boardId}
            className={`board-card state-${st} ${active ? "active" : ""} ${locked ? "locked" : ""}`}
            style={{ animationDelay: `${i * 0.04}s` }}
          >
            <div className="bc-head">
              <div>
                <div className="bc-num">BOARD {boardId}</div>
                <div className="bc-price">
                  {prices[i] ? fmtUsdt(prices[i]) : "—"}
                  <span> USDT</span>
                </div>
              </div>
              <span className={`b-status ${active ? "st-" + st : upgradable ? "up" : "off"}`}>
                {statusText}
              </span>
            </div>

            {active ? (
              <div className="bc-body">
                <Gauge
                  value={pct}
                  size={148}
                  label="ceiling"
                  variant={st === "warn" || st === "full" ? "gold" : "blue"}
                />
                <div className="bc-metrics">
                  <div className="metric">
                    <span className="m-k">Earned</span>
                    <span className="m-v">{fmtUsdt(det.totalEarned)} <i>USDT</i></span>
                  </div>
                  <div className="metric">
                    <span className="m-k">Balance Left</span>
                    <span className="m-v ok">{fmtUsdt(det.remainingLimit)} <i>USDT</i></span>
                  </div>
                  <div className="metric">
                    <span className="m-k">Ceiling (5x)</span>
                    <span className="m-v">{fmtUsdt(det.ceilingLimit)} <i>USDT</i></span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="bc-locked-note">
                {upgradable
                  ? `Activate for ${prices[i] ? fmtUsdt(prices[i]) : "—"} USDT.`
                  : "Activate the previous board to unlock."}
              </div>
            )}

            <div className="bc-actions">
              {active && (
                <Button size="sm" variant="secondary" loading={busy} onClick={() => retopup(boardId)}>
                  Re-topup
                </Button>
              )}
              {active && nextInactive && (
                <Button size="sm" variant="blue" loading={busy} onClick={() => upgrade(boardId + 1)}>
                  Upgrade to {boardId + 1} →
                </Button>
              )}
              {upgradable && (
                <Button size="sm" variant="" loading={busy} onClick={() => upgrade(boardId)}>
                  Activate Board {boardId}
                </Button>
              )}
            </div>
          </div>
        );
      })}
      </div>
    </div>
  );
}
